/*
 * "Vanaf"-label bij producten waarvan de varianten in prijs verschillen.
 *
 * snippets/price.liquid zet het label al in de HTML, maar de BSS B2B-app vervangt de prijs
 * daarna in de browser door de klantprijs en haalt het label daarbij weg. Dit script zet het
 * terug op elke .price met data-from-price, ook bij prijzen die later worden ingeladen
 * (variantwissel, filters, quick add).
 */
(function () {
  // Zou BSS de prijs blijven herschrijven zodra wij het label toevoegen, dan stopt het
  // script na dit aantal pogingen per prijs in plaats van eindeloos heen en weer te gaan.
  var MAX_REPAIRS = 10;
  var scheduled = false;

  function createLabel(text) {
    var fragment = document.createDocumentFragment();
    var label = document.createElement('span');
    label.className = 'from_info';
    label.textContent = text;
    fragment.appendChild(label);
    fragment.appendChild(document.createTextNode(' '));
    return fragment;
  }

  function repair(price) {
    var text = price.getAttribute('data-from-price');
    if (!text) return;

    var container = price.querySelector('.price__container') || price;
    var targets = container.querySelectorAll(
      '.price__regular > .price-item--regular, .price__sale > .price-item--sale'
    );
    var missing = [];

    for (var i = 0; i < targets.length; i++) {
      if (!targets[i].querySelector('.from_info')) missing.push(targets[i]);
    }
    if (targets.length === 0 && !container.querySelector('.from_info')) missing.push(container);
    if (missing.length === 0) return;

    var repairs = Number(price.getAttribute('data-from-price-repairs') || 0);
    if (repairs >= MAX_REPAIRS) return;
    price.setAttribute('data-from-price-repairs', repairs + 1);

    missing.forEach(function (target) {
      target.insertBefore(createLabel(text), target.firstChild);
    });
  }

  function run() {
    scheduled = false;
    document.querySelectorAll('.price[data-from-price]').forEach(repair);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }

  run();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
